// extracted by mini-css-extract-plugin
export default {"root":"k1zKip","title":"j_fxoE","subtitle":"LUyXyw","icon":"AJMeaI"};